import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PortalRegistrationComponent } from '@app/features/registration/views/portal-registration/portal-registration.component';
import { PortalLoginComponent } from '@app/features/login/views/portal-login/portal-login.component';
import { WorkCompDashbboardComponent } from '@app/features/workCompDashboard/views/work-comp-dashbboard/work-comp-dashbboard.component';
import { ReferralDashbboardComponent } from '@app/features/referralDashboard/views/referral-dashbboard/referral-dashbboard.component';
import { UserAuthGuard } from '../guards/userAuth.guard';
import { UserRoleGuard } from '../guards/userRole.guard';
import { UserRoles } from '../enums/userRoles.enum';
import { UnsavedChangesGuard } from '@app/shared/guards/unsaved-changes.guard';
import { WorkCompAccountPreferencesComponent } from '@app/features/workCompDashboard/views/work-comp-account-preferences/work-comp-account-preferences.component';
import { ReferralAccountPreferencesComponent } from '@app/features/referralDashboard/views/referral-account-preferences/referral-account-preferences.component';
import { AdminDashboardComponent } from '@app/features/adminDashboard/views/admin-dashboard/admin-dashboard.component';
import {
  AdminAccountPreferencesComponent
} from '@app/features/adminDashboard/views/admin-account-preferences/admin-account-preferences.component';
import { ExpiredPasswordComponent } from '@app/features/login/views/expired-password/expired-password.component';
import { PortalLoginForgotPasswordComponent } from '@app/features/login/views/forgot-password/portal-login-forgot-password.component';
import { PortalLoginResetPasswordComponent } from '@app/features/login/views/reset-password/portal-login-reset-password.component';
import { ForceChangePasswordComponent } from '@app/features/login/views/force-change-password/force-change-password.component';
import {userTypeRedirect} from "@app/core/routing/redirects.routing";
import {LoginPageGuard} from "@app/core/guards/loginPage.guard";
import {MainLayoutComponent} from "@app/layout/components/main-layout/main-layout.component";
import {BlankLayoutComponent} from "@app/layout/components/blank-layout/blank-layout.component";
import {DocumentPdfViewerComponent} from "@app/shared/components/document-pdf-viewer/document-pdf-viewer.component";

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: userTypeRedirect,
        pathMatch: 'full'
      },
      {
        path: 'portal-registration',
        component: PortalRegistrationComponent
      },
      {
        path: 'portal-login',
        component: PortalLoginComponent,
        canActivate: [LoginPageGuard],
      },
      {
        path: 'expired-password',
        component: ExpiredPasswordComponent
      },
      {
        path: 'force-change-password',
        component: ForceChangePasswordComponent
      },
      {
        path: 'forgot-password',
        component: PortalLoginForgotPasswordComponent
      },
      {
        path: 'reset-password',
        component: PortalLoginResetPasswordComponent
      },
      {
        path: 'wc-dashboard',
        component: WorkCompDashbboardComponent,
        canActivate: [UserAuthGuard, UserRoleGuard],
        data: {roles: [UserRoles.workCompUser]},
      },
      {
        path: 'wc-dashboard/preferences',
        component: WorkCompAccountPreferencesComponent,
        canActivate: [UserAuthGuard, UserRoleGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: {roles: [UserRoles.workCompUser]},
      },
      {
        path: 'ref-dashboard',
        component: ReferralDashbboardComponent,
        canActivate: [UserAuthGuard, UserRoleGuard],
        data: {roles: [UserRoles.referralUser]}
      },
      {
        path: 'ref-dashboard/preferences',
        component: ReferralAccountPreferencesComponent,
        canActivate: [UserAuthGuard, UserRoleGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: {roles: [UserRoles.referralUser]}
      },
      {
        path: 'admin-dashboard',
        component: AdminDashboardComponent,
        canActivate: [UserAuthGuard, UserRoleGuard],
        data: {roles: [UserRoles.adminUser]}
      },
      {
        path: 'admin-dashboard/preferences',
        component: AdminAccountPreferencesComponent,
        canActivate: [UserAuthGuard, UserRoleGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: {roles: [UserRoles.adminUser]}
      },
      {
        path: 'admin-dashboard/portal-requests/:userId',
        component: AdminDashboardComponent,
        canActivate: [UserAuthGuard, UserRoleGuard],
        data: {roles: [UserRoles.adminUser]}
      }
    ]
  },
  {
    path: '',
    component: BlankLayoutComponent,
    children: [
      {
        path: 'pdf-view/:personId/:documentId',
        component: DocumentPdfViewerComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule { }
